"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../../../../../../../../components/Button"));
var react_i18next_1 = require("react-i18next");
var formik_1 = require("formik");
var postSlice_1 = require("../../../../../../../../features/post/postSlice");
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var react_router_dom_1 = require("react-router-dom");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var FormAction = function (_a) {
    var formikProps = _a.formikProps, entityId = _a.entityId, handleSubmitApartmentForm = _a.handleSubmitApartmentForm, isApartmentFormSubmitted = _a.isApartmentFormSubmitted, collapsedApartmentId = _a.collapsedApartmentId;
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var id = react_router_dom_1.useParams().id;
    var publishedAt = react_redux_1.useSelector(postSlice_1.selectPost(id)).publishedAt;
    var submitForm = formik_1.useFormikContext().submitForm;
    var updateApartmentLoading = react_redux_1.useSelector(postSlice_1.selectUpdateApartmentLoading);
    react_1.useEffect(function () {
        if (isApartmentFormSubmitted && collapsedApartmentId === entityId) {
            var apartment = formikProps.values.apartment_info.find(function (item) { return item.entity_id === entityId; });
            dispatch(postSlice_1.updateEntity(entityId, __assign(__assign({}, apartment), { propertyType: formikProps.values.initial_info.property_type, deal: formikProps.values.deal, publishedAt: publishedAt })));
        }
    }, [isApartmentFormSubmitted]);
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var apartment;
        return __generator(this, function (_a) {
            formikProps.setErrors({});
            apartment = formikProps.values.apartment_info.find(function (item) { return item.entity_id === entityId; });
            handleSubmitApartmentForm(submitForm, apartment);
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement(Button_1.default, { variant: "primary", className: classnames_1.default('text-center', styles_module_scss_1.default.save_button), onClick: handleSubmit, disabled: updateApartmentLoading }, t('POST_SCREEN.SAVE')));
};
exports.default = react_1.memo(FormAction);
